"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.useStyles = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _GojobLogo = _interopRequireDefault(require("../GojobLogo"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Burger = _interopRequireDefault(require("../Icons/Burger"));

var _Background = _interopRequireDefault(require("./Background"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _TouchableOpacity = _interopRequireDefault(require("../TouchableOpacity"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing,
      colors = _useTheme.colors;

  return (0, _react.useMemo)(function () {
    return {
      root: {
        position: 'relative'
      },
      background: {
        zIndex: 0,
        width: '100%'
      },
      logo: {
        boxSizing: 'border-box',
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        height: '100%',
        width: 'auto',
        // Bigger bottom spacing is needed to manage the bottom shadow of the drawer
        padding: spacing(1.5, 0, 3.5, 0),
        color: colors.primary
      },
      content: {
        zIndex: 1,
        position: 'absolute',
        left: spacing(0.5),
        top: spacing(1),
        right: spacing(0.5),
        bottom: spacing(0.5)
      },
      menu: {
        alignSelf: 'baseline',
        minWidth: spacing(4),
        padding: spacing(1)
      }
    };
  }, [spacing, colors]);
};

exports.useStyles = useStyles;

__signature__(useStyles, "useTheme{{ spacing, colors }}\nuseMemo{}", function () {
  return [_useTheme2["default"]];
});

var MobileHeader = function MobileHeader(props, ref) {
  var children = props.children,
      hideMenu = props.hideMenu,
      onMenuClick = props.onMenuClick,
      BackgroundProps = props.BackgroundProps,
      containerProps = props.containerProps,
      other = (0, _objectWithoutProperties2["default"])(props, ["children", "hideMenu", "onMenuClick", "BackgroundProps", "containerProps"]);
  var classes = useStyles();
  return (0, _core.jsx)("header", (0, _extends2["default"])({
    css: classes.root
  }, other, {
    ref: ref
  }), (0, _core.jsx)(_Background["default"], (0, _extends2["default"])({
    css: classes.background
  }, BackgroundProps)), (0, _core.jsx)(_Flex["default"], (0, _extends2["default"])({
    justifyContent: "flex-end",
    css: classes.content
  }, containerProps), children !== null && children !== void 0 ? children : (0, _core.jsx)(_react["default"].Fragment, null, (0, _core.jsx)(_GojobLogo["default"], {
    "data-testid": "Logo",
    css: classes.logo
  }), (0, _core.jsx)(_Fade["default"], {
    "in": !hideMenu
  }, (0, _core.jsx)(_TouchableOpacity["default"], {
    css: classes.menu,
    "data-testid": "Menu",
    onClick: onMenuClick
  }, (0, _core.jsx)(_Icon["default"], {
    as: _Burger["default"],
    color: "primary",
    size: 6
  }))))));
};

__signature__(MobileHeader, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = (0, _react.forwardRef)(MobileHeader);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/MobileHeader/index.tsx");
  reactHotLoader.register(MobileHeader, "MobileHeader", "/builds/bA1zbJom/0/gojob/ui-bits/src/MobileHeader/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/MobileHeader/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();